import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Link,
  Snackbar,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import Alert from "../../ui/alert";
import { NavbarLoggedOut } from "../../ui/navbar";
import RecoveryPasswordFormModal from "./components/recovery-password-form-modal";
import V3features from "./features";
import "./home.css.scss";
import LoginForm from "./login_form";
import Footer from "./components/Footer";

const cardStyle = makeStyles({
  root: {
    maxWidth: "170px",
    height: "220px",
    margin: "15px",
    padding: "30px 10px",
    position: "relative",
  },
  media: {
    width: "75%",
    margin: "auto",
  },
});

const buttonStyles = makeStyles({
  root: {
    fontFamily: "Inter, sans-serif",
    borderRadius: "100px",
    zIndex: "1000",
    padding: "16px",
    marginTop: "22px",
    textTransform: "uppercase",
    backgroundColor: "#FB693B !important",
    "&:hover": {
      backgroundColor: "#E25022 !important",
    },
  },
  label: {
    color: "white",
    fontWeight: "bolder",
    fontSize: "13px !important",
  },
});

const LogoNote = require("images/pc_dados.png");
const LogoIcon = require("images/icon-blue.png");
const schedulingUrl =
  "https://calendly.com/mercatorio/demonstracao-plataforma-mercatorio";

const FeatureCard = ({ image, title, alt }) => {
  const classes = cardStyle();

  return (
    <Grid item>
      <Card className={classes.root} elevation={4}>
        <CardMedia
          className={classes.media}
          component="img"
          image={image}
          title={alt}
        />
        <CardContent
          style={{
            position: "absolute",
            bottom: "15px",
            left: "0",
            width: "100%",
          }}
        >
          <span className="h-card-title">{title}</span>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default () => {
  const [recoveryPasswordOpen, setRecoveryPasswordOpen] = useState(false);
  const [recoveryPasswordSuccess, setRecoveryPasswordSuccess] = useState(false);

  return (
    <div id="homepage">
      <NavbarLoggedOut />

      <Grid container spacing={0} style={{ padding: 0 }}>
        <Grid item sm={12} lg={7} style={{ paddingRight: 0 }}>
          <div className="h-about-wrapper">
            <div className="h-bg-about-section" />

            <div className="h-about-content">
              <h1 className="h-title">CONHEÇA A PLATAFORMA DE PRECATÓRIOS</h1>

              <p className="h-about-text">
                Aumente a sua produtividade na negociação de precatórios.
              </p>

              <p className="h-about-text">
                A plataforma que concentra no mesmo ambiente os dados de
                credores de precatórios e sistema de gerenciamento de
                negociações.
              </p>

              <hr className="h-about-sep" />
            </div>

            <div className="h-schedule-pc-section">
              <div className="h-schedule-btn-area">
                <Button
                  classes={buttonStyles()}
                  size="large"
                  color="default"
                  onClick={() => window.open(schedulingUrl, "_blank")}
                >
                  AGENDAR UMA DEMONSTRAÇÃO
                </Button>
              </div>

              <div className="h-pc-img-area">
                <img
                  className="h-pc-img"
                  src={LogoNote}
                  alt="Ícone Note Mercatório"
                />
              </div>
            </div>

            <div className="h-features-area">
              <h2 className="h-features-title">Recursos</h2>
              <Grid
                container
                direction="row"
                justify="space-evenly"
                alignItems="center"
              >
                <div className="h-cards-container">
                  {Object.keys(V3features).map((cardName, i) => {
                    const config = V3features[cardName];

                    return (
                      <FeatureCard
                        key={i}
                        alt={config.alt}
                        title={config.text}
                        image={config.img}
                      />
                    );
                  })}
                </div>
              </Grid>
            </div>
          </div>
        </Grid>

        <Grid item sm={12} lg={5} style={{ paddingLeft: 0, zIndex: 1 }}>
          <div className="h-form-area">
            <div className="h-icon-area">
              <img alt="Ícone Mercatório" src={LogoIcon} className="h-icon" />
            </div>

            <LoginForm />

            <div className="h-reset-area">
              <Link
                component="button"
                onClick={() => setRecoveryPasswordOpen(true)}
              >
                Esqueceu sua senha?
              </Link>
            </div>

            <RecoveryPasswordFormModal
              open={recoveryPasswordOpen}
              onClose={() => setRecoveryPasswordOpen(false)}
              onSuccess={() => {
                setRecoveryPasswordOpen(false);
                setRecoveryPasswordSuccess(true);
              }}
            />
          </div>
        </Grid>
      </Grid>

      <Snackbar
        open={recoveryPasswordSuccess}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setRecoveryPasswordSuccess(false)}
      >
        <Alert message="Se o seu email existir em nosso banco de dados, você receberá um email com um link para recuperação da senha." />
      </Snackbar>

      <Footer />
    </div>
  );
};
